import { useQuery } from 'react-query';
import { contentfulService } from 'services';
import { ServerStateKeysEnum } from '../constants';
import getConfig from 'next/config';

export const useContentful = (locale?: string, contentTypes?: string[]) => {
  const { publicRuntimeConfig } = getConfig();
  const storeRegion = publicRuntimeConfig.STORE_REGION;
  if (storeRegion.toUpperCase() === 'GCC' && locale !== 'tr-TR') {
    locale = 'en-GB';
  }
  const docLocale = locale || 'en-GB';
  return useQuery(
    ServerStateKeysEnum.contentfulData,
    () => contentfulService.getContentfulData(docLocale, contentTypes),
    { staleTime: Infinity, enabled: !!locale }
  );
};
